import { type LeadFormData } from "../LeadAddPage/components/lead-form-data.ts"
import { LEAD_STATUSES, type LeadStatusesValues } from "./lead-statuses.ts"

export type DeepBooleanPartial<T> = T extends (infer U)[]
  ? DeepBooleanPartial<U>[]
  : T extends object
    ? { [K in keyof T]?: DeepBooleanPartial<T[K]> }
    : boolean

type LeadRequiredFields = DeepBooleanPartial<LeadFormData>

// function deepMerge<T extends object>(target: T, source: T): T {
//   const result: any = { ...target }
//
//   for (const key in source) {
//     const value = source[key]
//
//     if (
//       value &&
//       typeof value === "object" &&
//       !Array.isArray(value) &&
//       typeof target[key] === "object"
//     ) {
//       result[key] = deepMerge(target[key] as any, value as any)
//     } else {
//       result[key] = value
//     }
//   }
//
//   return result
// }

// function buildRequiredFields<
//   T extends Record<string | number, LeadRequiredFields>
// >(raw: T): T {
//   const result: any = {}
//   let accumulated: LeadRequiredFields = {}
//
//   for (const key of Object.keys(raw)) {
//     accumulated = deepMerge(accumulated, raw[key])
//     result[key] = accumulated
//   }
//
//   return result
// }

// Final statuses that do not require verification of intermediate
const TERMINAL_STATUSES: LeadStatusesValues[] = [
  LEAD_STATUSES.NEW,
  // LEAD_STATUSES.NEGOTIATION,
  LEAD_STATUSES.LOST,
  LEAD_STATUSES.UNQUALIFIED
]

// They are statically required in the form itself
const COMMON_REQUIRED_FIELDS = {
  lead_name: true,
  source: false,
  customer: {
    first_name: true,
    last_name: false
  } satisfies DeepBooleanPartial<LeadFormData["customer"]>
} satisfies LeadRequiredFields

// const RAW_REQUIRED_FIELDS: Record<number | string, LeadRequiredFields> = {
//   [LEAD_STATUSES.NEW]: {},
//   [LEAD_STATUSES.CONTACTED]: {
//     address: true,
//     city: true,
//     state: true,
//     zip_code: true,
//     sales_manager: true,
//     customer: {
//       email: true,
//       phone: true,
//       address: true,
//       city: true,
//       state: true,
//       zip_code: true
//     }
//   },
//   [LEAD_STATUSES.QUALIFIED]: {},
//   [LEAD_STATUSES.ESTIMATE]: {},
//   [LEAD_STATUSES.NEGOTIATION]: {},
//   [LEAD_STATUSES.WON]: {},
//   [LEAD_STATUSES.LOST]: {},
//   [LEAD_STATUSES.UNQUALIFIED]: {},
//   [LEAD_STATUSES.NURTURING]: {}
// }

// const REQUIRED_FIELDS_BY_STATUS = buildRequiredFields(RAW_REQUIRED_FIELDS)

export { COMMON_REQUIRED_FIELDS, TERMINAL_STATUSES, type LeadRequiredFields }
